import './NavItem.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

/**
 * NavItem Component
 * @augments {Component<Props, State>}
 */
class NavItem extends Component {
    render() {
        const { to, label, className, ...rest } = this.props;
        return (
            <NavLink className={`NavItem ${className}`} activeClassName={'active'} to={to} {...rest}>{label}</NavLink>
        );
    }
}

NavItem.defaultProps = {
    className: '',
};

NavItem.propTypes = {
    className: PropTypes.string,
    to: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

export default NavItem;